import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {CustomerService} from '../../services/customers.service';
import {Customer} from '../../models/customer.model';
import {ConfirmationService} from 'primeng/primeng';
import {Router} from '@angular/router';

@Component({
  providers: [CustomerService],
  styleUrls: ['./customers.component.scss'],
  selector: 'app-customers',
  templateUrl: './customers.component.html',
})
export class CustomersComponent implements OnInit {
  public customers: Customer[];
  public cols: any[];

  private _selectedCustomer: Customer;

  constructor(private _customersService: CustomerService, private _elementReference: ElementRef, public router: Router) {
    this._customersService.customers$.subscribe((customers) => {
      this.customers = customers;
    });
  }

  public ngOnInit(): void {
    this.cols = [
      { field: 'name', header: 'Naam' },
      { field: 'city', header: 'Plaats' },
      { field: 'contact', header: 'Contact' }
    ];

    this._customersService.loadAll();
  }


  set selectedCustomer(value) {
    this._selectedCustomer = value;
    this.detailsCustomer();
  }
  get selectedCustomer(): Customer {
    return this._selectedCustomer;
  }

  public addCustomer(): void {
    this.router.navigate(['/customers/new']);
  }

  private detailsCustomer(): void {
    if (this.selectedCustomer) {
      this.router.navigate(['/customers', this.selectedCustomer._id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/customer/customers.component.ts